/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ average: NonNullable<unknown>, previous: NonNullable<unknown> }} Practice_Trend_EqualInputs */



/**
* | output |
* | --- |
* | "Average {average} — same as {previous}" |
*
* @param {Practice_Trend_EqualInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_trend_equal = /** @type {((inputs: Practice_Trend_EqualInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Trend_EqualInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Gemiddelde ${i?.average} — gelijk aan ${i?.previous}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Moyenne ${i?.average} — comme ${i?.previous}`)
	return /** @type {LocalizedString} */ (`Average ${i?.average} — same as ${i?.previous}`)
});